import { render } from "./PreServicios.vue?vue&type=template&id=60532ee3&scoped=true"
const script = {}

import "./PreServicios.vue?vue&type=style&index=0&id=60532ee3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60532ee3"]])

export default __exports__